import React, { useEffect, useState } from 'react';
import { PreviewFile } from './MediaViewer';
import { useWheelZoomNative } from './useWheelZoomNative';

interface MediaViewerDisplayImageProps {
	file: PreviewFile;
}

export default function MediaViewerDisplayImage(
	props: MediaViewerDisplayImageProps,
) {
	const { file } = props;
	const [zoomLoaded, setZoomLoaded] = useState(false);
	const [imageLoaded, setImageLoaded] = useState(false);
	const { wheelZoomNative } = useWheelZoomNative();

	const img = document.getElementById('zoom-image-detail');
	useEffect(() => {
		if (!zoomLoaded && img) {
			wheelZoomNative(img, {});
			setZoomLoaded(true);
		}
	}, [img, imageLoaded]);

	return (
		<div
			className='d-flex align-items-center justify-content-center zoomable-image'
			style={{ overflow: 'hidden' }}
		>
			<img
				src={file.download}
				alt={file.displayName}
				id='zoom-image-detail'
				onLoad={() => setImageLoaded(true)}
			/>
		</div>
	);
}
